<div
  class="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-ink/80 px-4 py-10"
  (click)="close()"
>
  <div
    class="w-full max-w-2xl rounded-md border border-hairline bg-panel p-6"
    (click)="$event.stopPropagation()"
  >
    <div class="mb-4 flex items-start justify-between gap-4">
      <div>
        <h2 class="font-display text-xl font-semibold text-parchment">{{ displayName() }}</h2>
        <p class="text-sm text-dusk">{{ email() }}</p>
      </div>
      <button
        type="button"
        (click)="close()"
        class="text-xl leading-none text-dusk hover:text-parchment"
        aria-label="Close"
      >
        &times;
      </button>
    </div>

    @if (loading()) {
      <p class="text-dusk">Loading…</p>
    } @else if (errorMessage()) {
      <p class="rounded border border-wax/40 bg-wax/10 px-4 py-3 text-sm text-parchment">
        {{ errorMessage() }}
      </p>
    } @else if (history().length === 0) {
      <p class="text-sm text-dusk">Not in any of your other competitions.</p>
    } @else {
      <ul class="flex flex-col gap-4">
        @for (entry of history(); track entry.competition.id) {
          <li class="rounded border border-hairline p-4">
            <h3 class="mb-3 text-sm font-semibold text-parchment">
              {{ entry.competition.name }}
              @if (entry.competition.id === competitionId()) {
                <span class="ml-1 text-xs font-normal uppercase tracking-wide text-gold">(this competition)</span>
              }
            </h3>
            <app-pick-list [picks]="entry.picks" />
          </li>
        }
      </ul>
    }
  </div>
</div>
